import type { Psbt } from 'bitcoinjs-lib';

import type {
  BitcoinSignPsbtRequest,
  SignPsbtOptions,
} from '../../BitcoinWalletProvider.types';
import { validatePsbt } from '../validatePsbt';

type CreatePsbtOptionsParams = {
  psbt: Psbt;
  request: BitcoinSignPsbtRequest;
};

/**
 * This method will create the psbt sign options for the given request
 * It will validate the psbt against the signature data provided in the request
 * It will return the psbt sign options with the toSignInputs added if the signature data is provided
 */
export const createPsbtOptions = ({
  psbt,
  request,
}: CreatePsbtOptionsParams) => {
  const psbtSignOptions: SignPsbtOptions = {
    autoFinalized: false,
  };

  if (!request.signature) {
    return psbtSignOptions;
  }

  validatePsbt({
    allowedSigHashTypes: request.allowedSighash,
    psbt,
    signatureData: request.signature,
  });

  const toSignInputs: SignPsbtOptions['toSignInputs'] = [];

  for (const signature of request.signature) {
    if (signature.signingIndexes?.length) {
      for (const index of signature.signingIndexes) {
        toSignInputs.push({
          address: signature.address,
          disableAddressValidation: signature.disableAddressValidation,
          index,
          sighashTypes: request.allowedSighash,
        });
      }
    }
  }

  psbtSignOptions.toSignInputs = toSignInputs;

  return psbtSignOptions;
};
